export default __webpack_public_path__ + "static/media/partying-face.5fd16487.svg";